/**
 * Edition configuration — build-time switch between standalone and cloud.
 *
 * Default is standalone (private deployment / local dev).
 * Set VITE_EDITION=cloud at build time for managed SaaS marketing site.
 *
 * Cloud edition: marketing homepage at `/`, full navbar/footer, pricing/signup/trust routes.
 * Standalone edition: Dev Portal at `/`, minimal chrome, no public marketing routes.
 */

const rawEdition = import.meta.env.VITE_EDITION as string | undefined

export const EDITION = (rawEdition === 'cloud' ? 'cloud' : 'standalone') as 'standalone' | 'cloud'

export const isStandalone = EDITION === 'standalone'
export const isCloud = EDITION === 'cloud'
